import useDefineComponent from "./plugins/useDefineComponent";


class ReactiveZoneGlobal {
    static defineComponent = useDefineComponent
}

export default ReactiveZoneGlobal